<h2 class="title">Registrarse</h2>
<form (ngSubmit)="register()" #form="ngForm">
    <div *ngIf="errors && errors.length > 0 && !submitted" class="alert alert-danger" role="alert">
        <div><strong>Lo siento!</strong></div>
        <div *ngFor="let error of errors">{{ error }}</div>
    </div>
    <div *ngIf="messages && messages.length > 0 && !submitted" class="alert alert-success" role="alert">
        <div><strong>¡Felicitaciones!</strong></div>
        <div *ngFor="let message of messages">{{ message }}</div>
    </div>

    <div class="form-group">
        <label for="input-documentType">Tipo de identificaci&oacute;n</label>
        <select name="documentType" [required]="getConfigValue('forms.validation.documentType.required')"
            [(ngModel)]="user.documentType" id="input-documentType" #documentType="ngModel" class="form-control"
            autofocus>
            <option *ngFor="let type of documentTypes | keyvalue" [ngValue]="type.key">{{type.value}}
            </option>

        </select>
        <small class="form-text error"
            *ngIf="documentType.invalid && documentType.touched && documentType.errors?.required">
            ¡Tipo de identificaci&oacute;n requerido!
        </small>
    </div>

    <div class="form-group">
        <label for="input-document" class="sr-only">Identificaci&oacute;n</label>
        <input name="document" [(ngModel)]="user.document" id="input-document" #document="ngModel" class="form-control"
            placeholder="Identificaci&oacute;n" [class.form-control-danger]="document.invalid && document.touched"
            [required]="getConfigValue('forms.validation.document.required')"
            [minlength]="getConfigValue('forms.validation.document.minLength')"
            [maxlength]="getConfigValue('forms.validation.document.maxLength')">
        <small class="form-text error" *ngIf="document.invalid && document.touched && document.errors?.required">
            Identificaci&oacute;n requerida!
        </small>
        <small class="form-text error"
            *ngIf="document.invalid && document.touched && (document.errors?.minlength || document.errors?.maxLength)">
            Nombres debe contener
            de {{getConfigValue('forms.validation.document.minLength')}}
            a {{getConfigValue('forms.validation.document.maxLength')}}
            caracteres
        </small>
    </div>

    <div class="form-group">
        <label for="input-name" class="sr-only">Nombres</label>
        <input name="firstName" [(ngModel)]="user.firstName" id="input-name" #firstName="ngModel" class="form-control"
            placeholder="Nombres" [class.form-control-danger]="firstName.invalid && firstName.touched"
            [required]="getConfigValue('forms.validation.firstName.required')"
            [minlength]="getConfigValue('forms.validation.firstName.minLength')"
            [maxlength]="getConfigValue('forms.validation.firstName.maxLength')">
        <small class="form-text error" *ngIf="firstName.invalid && firstName.touched && firstName.errors?.required">
            ¡Nombres requeridos!
        </small>
        <small class="form-text error"
            *ngIf="firstName.invalid && firstName.touched && (firstName.errors?.minlength || firstName.errors?.maxLength)">
            Nombres debe contener
            de {{getConfigValue('forms.validation.firstName.minLength')}}
            a {{getConfigValue('forms.validation.firstName.maxLength')}}
            caracteres
        </small>
    </div>

    <div class="form-group">
        <label for="input-name" class="sr-only">Apellidos</label>
        <input name="lastName" [(ngModel)]="user.lastName" id="input-name" #lastName="ngModel" class="form-control"
            placeholder="Apellidos" [class.form-control-danger]="lastName.invalid && lastName.touched"
            [required]="getConfigValue('forms.validation.lastName.required')"
            [minlength]="getConfigValue('forms.validation.lastName.minLength')"
            [maxlength]="getConfigValue('forms.validation.lastName.maxLength')" autofocus>
        <small class="form-text error" *ngIf="lastName.invalid && lastName.touched && lastName.errors?.required">
            ¡Apellidos requeridos!
        </small>
        <small class="form-text error"
            *ngIf="lastName.invalid && lastName.touched && (lastName.errors?.minlength || lastName.errors?.maxLength    )">
            Apellidos debe contener
            de {{getConfigValue('forms.validation.lastName.minLength')}}
            a {{getConfigValue('forms.validation.lastName.maxLength')}}
            caracteres
        </small>
    </div>

    <div class="form-group">
        <label for="input-address" class="sr-only">Direcci&oacute;n</label>
        <input name="address" [(ngModel)]="user.address" id="input-address" #address="ngModel" class="form-control"
            placeholder="Direcci&oacute;n" [class.form-control-danger]="address.invalid && address.touched"
            [required]="getConfigValue('forms.validation.address.required')"
            [minlength]="getConfigValue('forms.validation.address.minLength')"
            [maxlength]="getConfigValue('forms.validation.address.maxLength')">
        <small class="form-text error" *ngIf="address.invalid && address.touched && address.errors?.required">
            ¡Direcci&oacute;n requerida!
        </small>
        <small class="form-text error"
            *ngIf="address.invalid && address.touched && (address.errors?.minlength || address.errors?.maxLength    )">
            Direcci&oacute;n debe contener
            de {{getConfigValue('forms.validation.address.minLength')}}
            a {{getConfigValue('forms.validation.address.maxLength')}}
            caracteres
        </small>
    </div>

    <div class="form-group">
        <label for="input-addressInfo" class="sr-only">Complementeo de direcci&oacute;n</label>
        <input name="addressInfo" [(ngModel)]="user.addressInfo" id="input-addressInfo" #addressInfo="ngModel"
            class="form-control" placeholder="Complemento de direcci&oacute;n"
            [class.form-control-danger]="addressInfo.invalid && addressInfo.touched"
            [required]="getConfigValue('forms.validation.addressInfo.required')">
        <small class="form-text error"
            *ngIf="addressInfo.invalid && addressInfo.touched && addressInfo.errors?.required">
            ¡Complemento de direcci&oacute;n requerida!
        </small>
    </div>

    <div class="form-group">
        <label for="input-state">Departamento</label>
        <select name="state" [required]="getConfigValue('forms.validation.state.required')" [(ngModel)]="user.state"
            id="input-state" #state="ngModel" class="form-control" autofocus (change)="updateState()">
            <option *ngFor="let state of country.states" [ngValue]="state.name">{{state.name}}
            </option>

        </select>
        <small class="form-text error" *ngIf="state.invalid && state.touched && state.errors?.required">
            ¡Departamento requerido!
        </small>
    </div>

    <div class="form-group">
        <label for="input-city">Ciudad</label>
        <select name="city" [required]="getConfigValue('forms.validation.city.required')" [(ngModel)]="user.city"
            id="input-city" #city="ngModel" class="form-control" autofocus>
            <option value="">Seleccione una ciudad..</option>
            <option *ngFor="let city of cities()" [ngValue]="city.name">{{city.name}}
            </option>

        </select>
        <small class="form-text error" *ngIf="city.invalid && city.touched && city.errors?.required">
            ¡Ciudad requerida!
        </small>
    </div>

    <div class="form-group">
        <label for="input-phone" class="sr-only">Tel&eacute;fono</label>
        <input name="phone" [(ngModel)]="user.phone" id="input-phone" #phone="ngModel" class="form-control"
            placeholder="Tel&eacute;fono" [class.form-control-danger]="phone.invalid && phone.touched"
            [required]="getConfigValue('forms.validation.phone.required')"
            [minlength]="getConfigValue('forms.validation.phone.minLength')"
            [maxlength]="getConfigValue('forms.validation.phone.maxLength')">
        <small class="form-text error" *ngIf="phone.invalid && phone.touched && phone.errors?.required">
            ¡Tel&eacute;fono requerido!
        </small>
        <small class="form-text error"
            *ngIf="phone.invalid && phone.touched && (phone.errors?.minlength || phone.errors?.maxLength    )">
            Tel&eacute;fono debe contener
            de {{getConfigValue('forms.validation.phone.minLength')}}
            a {{getConfigValue('forms.validation.phone.maxLength')}}
            caracteres
        </small>
    </div>

    <div class="form-group">
        <label for="input-cellularPhone" class="sr-only">Celular</label>
        <input name="cellularPhone" [(ngModel)]="user.cellularPhone" id="input-cellularPhone" #cellularPhone="ngModel"
            class="form-control" placeholder="Celular"
            [class.form-control-danger]="cellularPhone.invalid && cellularPhone.touched"
            [required]="getConfigValue('forms.validation.cellularPhone.required')"
            [minlength]="getConfigValue('forms.validation.cellularPhone.minLength')"
            [maxlength]="getConfigValue('forms.validation.cellularPhone.maxLength')">
        <small class="form-text error"
            *ngIf="cellularPhone.invalid && cellularPhone.touched && cellularPhone.errors?.required">
            ¡Celular requerido!
        </small>
        <small class="form-text error"
            *ngIf="cellularPhone.invalid && cellularPhone.touched && (cellularPhone.errors?.minlength || cellularPhone.errors?.maxLength    )">
            Celular debe contener
            de {{getConfigValue('forms.validation.cellularPhone.minLength')}}
            a {{getConfigValue('forms.validation.cellularPhone.maxLength')}}
            caracteres
        </small>
    </div>

    <div class="form-group">
        <label for="input-email" class="sr-only">Correo electr&oacute;nico</label>
        <input name="email" [(ngModel)]="user.email" id="input-email" #email="ngModel" class="form-control"
            placeholder="Correo electr&oacute;nico" pattern=".+@.+\..+"
            [class.form-control-danger]="email.invalid && email.touched"
            [required]="getConfigValue('forms.validation.email.required')">
        <small class="form-text error" *ngIf="email.invalid && email.touched && email.errors?.required">
            ¡El Correo electr&oacute;nico es requerido!
        </small>
        <small class="form-text error" *ngIf="email.invalid && email.touched && email.errors?.pattern">
            ¡El Correo electr&oacute;nico debe ser v&aacute;lido!
        </small>
    </div>

    <div class="form-group">
        <label for="input-password" class="sr-only">Contrase&ntilde;a</label>
        <input name="password" [(ngModel)]="user.password" type="password" id="input-password" class="form-control"
            placeholder="Contrase&ntilde;a" #password="ngModel"
            [class.form-control-danger]="password.invalid && password.touched"
            [required]="getConfigValue('forms.validation.password.required')" [minlength]="getConfigValue('forms.validation.password.minLength')"
            [maxlength]="getConfigValue('forms.validation.password.maxLength')">
        <small class="form-text error" *ngIf="password.invalid && password.touched && password.errors?.required">
            Contrase&ntilde;a requerida!
        </small>
        <small class="form-text error"
            *ngIf="password.invalid && password.touched && (password.errors?.minlength || password.errors?.maxLength)">
            Contrase&ntilde;a debe contener
            from {{ validation.password.minLength }}
            to {{ validation.password.maxLength }}
            characters
        </small>
    </div>

    <div class="form-group">
        <label for="input-re-password" class="sr-only">Confirmar contrase&ntilde;a</label>
        <input name="rePass" [(ngModel)]="user.confirmPassword" type="password" id="input-re-password"
            class="form-control" placeholder="Confirmar contrase&ntilde;a" #rePass="ngModel"
            [class.form-control-danger]="(rePass.invalid || password.value != rePass.value) && rePass.touched"
            [required]="getConfigValue('forms.validation.password.required')">
        <small class="form-text error" *ngIf="rePass.invalid && rePass.touched && rePass.errors?.required">
            Confirmaci&oacute;n de contrase&ntilde;a es requerida!
        </small>
        <small class="form-text error"
            *ngIf="rePass.touched && password.value != rePass.value && !rePass.errors?.required">
            Contrase&ntilde;as no coinciden
        </small>
    </div>


    <div class="form-group accept-group col-sm-12" *ngIf="getConfigValue('forms.register.terms')">
        <nb-checkbox name="terms" [(ngModel)]="user.terms" [required]="getConfigValue('forms.register.terms')">
            Aceptar <a href="#" target="_blank"><strong>T&eacute;rminos & Condiciones</strong></a>
        </nb-checkbox>
    </div>

    <button nbButton fullWidth [disabled]="submitted || !form.valid" class="btn btn-block btn-hero-success"
        [class.btn-pulse]="submitted" status="primary">

        Registrar
    </button>
</form>
<div class="links">
    <ng-container *ngIf="socialLinks && socialLinks.length > 0">
        <small class="form-text">O con&eacute;ctate con:</small>
        <div class="socials">
            <ng-container *ngFor="let socialLink of socialLinks">
                <a (click)="loginSocial(socialLink.name)" [attr.class]="socialLink.icon"
                    [class.with-icon]="socialLink.icon" style="cursor: pointer;">{{ socialLink.title }}</a>
            </ng-container>
        </div>
    </ng-container>
    <small class="form-text">
        ¿Ya tienes cuenta? <a routerLink="../login"><strong>Ingresa</strong></a>
    </small>
</div>